/*
 * TODO: I couldn't found tron in caip
 * @see https://namespaces.chainagnostic.org/
 */

// if the value needs to be change make sure you will update mapCaipNamespaceToLegacyNetworkName as well
export const CAIP_NAMESPACE = 'tron';
export const CAIP_TRON_CHAIN_ID = 'tron';
